import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context';
import { IItem } from './types';
import { resolve } from 'path';

export function useDeleteItemMutation(itemId: string) {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetch(`/api/item/${itemId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
      }),
    mutationKey: ['itemDelete', itemId],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['items'] });
    }
  });
}